import React from "react";
import useRouter from "use-react-router";
import { useTranslation } from "react-i18next";
import { Gig } from "gql-gen";
import { getAppUrl } from "utilities/routes";
import { Link } from "react-router-dom";

import { UserInfo, useUserInfo } from "modules/Dashboard/UserInfo";

import { isEditable } from "utilities/gigAccess";
import { TFunction } from "i18next";
import { Location } from "history";

import styles from "./styles.scss";

interface EditLinkProps {
  isEditing: boolean;
  userInfo: UserInfo;
  location: Location;
  t: TFunction;
  gigId: string;
}

const EditLink: React.FC<EditLinkProps> = ({ isEditing, userInfo, location, t, gigId }) => {
  const isAppOnly = userInfo?.me?.organizationUser.theAppReportsEnabled;
  const label = t(`gigs.cells.reportOverview.${isEditing ? "view" : "edit"}`);

  if (isAppOnly) {
    return (
      <a href={getAppUrl("theApp", `${userInfo?.me?.organizationUser.organizationId}/reports/${gigId}`)} target="_blank" rel="noopener noreferrer">
        <button className={styles.editButton}>{label}</button>
      </a>
    );
  }

  return (
    <Link
      to={{
        ...location,
        pathname: isEditing
          ? location.pathname.split("/+edit-report")[0]
          : location.pathname + "/+edit-report",
      }}
    >
      <button className={styles.editButton}>{label}</button>
    </Link>
  );
};

interface EditReportLinksProps {
  gig: Gig;
  className?: string;
}

export const EditReportLinks: React.FC<EditReportLinksProps> = ({ gig, className }) => {
  const userInfo = useUserInfo();
  const { t } = useTranslation();
  const { location } = useRouter();
  const isEditing = location.pathname.includes("/+edit-report");

  const { editable } = isEditable(gig, userInfo, 'dashboard');

  if (!editable) {
    return null;
  }

  return (
    <div className={className}>
      <EditLink isEditing={isEditing} userInfo={userInfo} location={location} t={t} gigId={gig.id} />
    </div>
  );
};
